<template>
	<el-row>
		<el-row>
			<el-button @click="add()">添加</el-button>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="6">
				<el-input v-model="columnName" placeholder="请输入统计项名称"></el-input>
			</el-col>
			<el-col :span="6">
				<el-button @click="chaxuan()">查询</el-button>
			</el-col>
		</el-row>
		<el-table :data="tableData" border style="width: 100%; margin-top: 20px">
			<el-table-column label="id" prop="id"></el-table-column>
			<el-table-column label="统计项" prop="columnName"></el-table-column>
			<el-table-column label="创建时间" prop="created"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="bianji(scope.row)">编辑</el-button>
					<el-button type="text" @click="xiangqing(scope.row)">详情</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog :title="title" :visible.sync="dialogVisible" center width="30%">
			<el-form :model="info" ref="info">
				<el-form-item label="统计项" label-width="70px" prop="columnName" :rules="[{
                     required: true, message: '请输入统计项', trigger: 'blur' }]">
					<el-input v-model="info.columnName"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="sumbit">确认</el-button>
			</span>
		</el-dialog>
		<el-drawer title="推荐课程" :visible.sync="drawer" direction="btt" :before-close="handleClose" size="70%">
			<el-row style="display: flex;justify-content: space-around;" :gutter="20">
				<el-col :span="7" v-for="(item,index) in tableData2" style="display: flex;flex-direction: column;">
					<div style="margin-bottom: 20px">
						<el-button @click="tianjia(item,index)">添加</el-button>
					</div>
					<div style="font-weight: bold;margin: 20px auto;">
						{{item.level == 0 ? '正常' : item.level == 1?'偏低': item.level ==2?'极低':''}}
					</div>
					<el-table :data="item.maps">
						<el-table-column label="id" prop="courseId"></el-table-column>
						<el-table-column label="名称" prop="courseName"></el-table-column>
						<el-table-column label="图片" prop="courseId">
							<template slot-scope="scope">
								<el-image :src="scope.row.pic" style="width: 80px;;height: 50px;"></el-image>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
		</el-drawer>
		<el-dialog title="课程列表" :visible.sync="dialogVisible2" center>
			<el-button @click="choose" type="primary">确认添加</el-button>
			<el-table :data="tableData3" ref="multipleTable" row-key="courseId"
				@selection-change="handleSelectionChange">
				<el-table-column type="selection" :reserve-selection="true">
				</el-table-column>
				<el-table-column label="id" prop="courseId" width="50px">
				</el-table-column>
				<el-table-column label="名称" prop="courseName"></el-table-column>
				<el-table-column label="图片">
					<template slot-scope="scope">
						<el-image :src="scope.row.pic" style="width: 88px;;height: 50px;"></el-image>
					</template>
				</el-table-column>
			</el-table>
			<div style="margin: 20px auto;width: 500px">
				<el-pagination background layout="total, prev, pager, next,jumper" :page-size="pageSize" :total="total"
					:page-sizes="[5,10]" :current-page.sync="pageNum" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" />
			</div>
		</el-dialog>
	</el-row>
</template>

<script>
	import axios from 'axios';
	export default {
		data() {
			return {
				id: 0,
				id2: 0,
				id3: 0,
				select: false,
				tableData: [],
				tableData2: [],
				tableData3: [],
				total: 0,
				pageSize: 5,
				pageNum: 1,
				dialogVisible: false,
				dialogVisible2: false,
				drawer: false,
				title: '',
				columnName: '',
				kcoptions: [],
				info: {
					columnName: ''
				},
				kcArr: [],
				chooseKc: []
			}
		},
		methods: {
			//添加课程
			choose() {
				this.$confirm('确认添加所选课程吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('https://qcn.xinian727.com/qunce/dataColumn/updateColumnDetail', {
						"detailId": this.id2,
						"courseIds": this.kcArr
					}).then(res => {
						console.log(res.data);
						if (res.data.status == 0) {
							this.$message.success('添加成功');
							this.dialogVisible2 = false
							this.getKc(this.id3)
						}
					})
				}).catch(() => {
					this.$message.info('已取消删除');
				});
			},
			//选择课程
			handleSelectionChange(selection) {
				console.log(selection);
				this.kcArr = selection.map(item => item.courseId)
			},
			//添加统计项
			add() {
				this.title = '添加统计项'
				this.dialogVisible = true
				this.info.columnName = ''
			},
			//打开添加课程
			tianjia(item2, index) {
				this.chooseKc = item2.courseIds
				console.log(item2.courseIds);
				this.dialogVisible2 = true
				this.id2 = item2.detailId
				this.$nextTick(function() {
					this.$refs.multipleTable.clearSelection()
					this.tableData3.forEach(item => {
						if (item2.courseIds.some(data => data === item.courseId)) {
							this.$refs.multipleTable.toggleRowSelection(item, true)
						}
					})
				})
			},
			//编辑统计项
			bianji(row) {
				console.log(row);
				this.title = '编辑统计项'
				this.dialogVisible = true
				this.id = row.id
				this.info.columnName = row.columnName
			},
			//打开详情
			xiangqing(row) {
				console.log(row);
				this.id3 = row.id
				this.drawer = true
				this.getKc(row.id)
			},
			//获取详情
			getKc(id) {
				this.$http.post('https://qcn.xinian727.com/qunce/dataColumn/selectColumnDetail', {
					id: id
				}).then(res => {
					console.log(res.data.data);
					this.tableData2 = res.data.data
				}).catch((error) => {
					this.$message.error("发生了一些错误:" + error);
				})
			},
			sumbit() {
				this.$refs.info.validate(vai => {
					if (vai) {
						if (this.id == 0) {
							this.$http.post('https://qcn.xinian727.com/qunce/dataColumn/insertColumn', {
								columnName: this.info.columnName
							}).then(res => {
								if (res.data.status == 0) {
									this.$message.success(res.data.data)
									this.dialogVisible = false
									this.getList()
								} else {
									this.$message.error(res.data.msg)
								}
							})
						} else {
							this.$http.post('https://qcn.xinian727.com/qunce/dataColumn/updateColumn', {
								id: this.id,
								columnName: this.info.columnName
							}).then(res => {
								if (res.data.status == 0) {
									this.$message.success(res.data.data)
									this.dialogVisible = false
									this.getList()
								} else {
									this.$message.error('编辑失败')
								}
							})
						}
					}
				})

			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			chaxuan() {
				this.getList()
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				this.getKeCheng()
				console.log(this.tableData3);
				console.log(this.chooseKc);
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				// this.getKeCheng()
				this.$http.post(
					`https://qcn.xinian727.com/qunce/dataColumn/getCourse?PageSize=${this.pageSize}&PageNum=${this.pageNum}`, {}
				).then(
					res => {
						console.log(res.data.data.list);
						this.tableData3 = res.data.data.list
						this.total = res.data.data.total
						console.log(this.chooseKc);
						this.$nextTick(function() {
							res.data.data.list.forEach(item => {
								if (this.chooseKc.some(data => data === item.courseId)) {
									this.$refs.multipleTable.toggleRowSelection(item, true)
								}
							})
						})
					}).catch((error) => {
					this.$message.error("发生了一些错误:" + error);
				})

			},
			getList() {
				this.$http.post('https://qcn.xinian727.com/qunce/dataColumn/selectColumn', {
					columnName: this.columnName
				}).then(res => {
					console.log(res.data.data);
					this.tableData = res.data.data
				})
			},
			//课程
			getKeCheng() {
				this.$http.post(
					`https://qcn.xinian727.com/qunce/dataColumn/getCourse?PageSize=${this.pageSize}&PageNum=${this.pageNum}`, {}
				).then(
					res => {
						console.log(res.data.data.list);
						this.tableData3 = res.data.data.list
						this.total = res.data.data.total
					}).catch((error) => {
					this.$message.error("发生了一些错误:" + error);
				})
			},
		},
		created() {
			this.getKeCheng()
			this.getList()
		},
	}
</script>


<style scoped>
	.box {
		width: 110%;
		height: 30px;
		margin-left: -10px;
	}

	.box:nth-child(2) {
		height: 50px;
		border-top: 1px solid #ced4d9;
		border-bottom: 1px solid #ced4d9;
	}

	.flex {
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>
